const $ = jQuery.noConflict();

const scrollDownInit = function() {
    const scrollDownTriggers = document.querySelectorAll('.btn-scroll-down');

    for (let i = 0; i < scrollDownTriggers.length; i++) {
        const element = scrollDownTriggers[i];
        const parentEl = element.closest('section');
        const header = document.querySelector('.main-header');

        if(element.classList.contains('scrolldown-init') || parentEl === null) {
            return;
        }

        element.classList.add('scrolldown-initialized');
        element.addEventListener('click', () => {
            let parentBottom = parentEl.offsetTop + parentEl.offsetHeight;

            if(header !== null) {
                parentBottom = parentBottom - header.offsetHeight;
            }

            $('html, body').animate({
                scrollTop: parentBottom,
            }, 600);
        });
    }
}

export default scrollDownInit;